import * as St from './InputOption.styles';

type InputType = 'checkbox' | 'radio';

export type InputOptionProps = {
  id?: string;
  type: InputType;
  styleType?: InputType;
  value: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  label: React.ReactNode;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
};

export const InputOption = ({
  id,
  type,
  styleType,
  value,
  isChecked,
  isDisabled,
  label,
  onChange,
  className,
  ...props
}: InputOptionProps) => (
  <St.Container className={className}>
    <St.Input
      type={type}
      id={`${id || value}`}
      value={value}
      onChange={isDisabled ? undefined : onChange}
      checked={isChecked}
      disabled={isDisabled}
      data-style={styleType ?? type}
      {...props}
    />
    <St.Label htmlFor={`${id || value}`}>{label}</St.Label>
  </St.Container>
);

export default InputOption;
